import { createFileRoute, getRouteApi, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { assetQuery } from '../../data/assets.ts'
import { deviceListQuery } from '../../data/devices.ts'
import { lightningProtectionsQuery } from '../../data/protections/lightning.ts'
import { protectionsQuery } from '../../data/protections/protections.ts'
import { ProtectionForm } from '../../features/alerts/ProtectionForm.tsx'

export const Route = createFileRoute('/_app/alerts/add')({
	validateSearch: z.object({ locationId: z.string().optional() }),
	component: RouteComponent,
	beforeLoad: async ({ context: { queryClient, impersonation, isAdmin, sub } }) => {
		if (!isAdmin) {
			throw redirect({ to: '/' })
		}
		const hasProtectionsSub = sub.features.includes('protections')
		await Promise.all([
			queryClient.ensureQueryData(assetQuery(impersonation, { enabled: hasProtectionsSub })),
			queryClient.ensureQueryData(deviceListQuery(impersonation?.partyAccountId)),
			queryClient.ensureQueryData(protectionsQuery(impersonation, { enabled: hasProtectionsSub })),
			queryClient.ensureQueryData(lightningProtectionsQuery(impersonation, { enabled: hasProtectionsSub })),
		])
	},
})

const route = getRouteApi('/_app/alerts/add')

function RouteComponent() {
	const { locationId } = route.useSearch({ select: ({ locationId }) => ({ locationId }) })
	return <ProtectionForm locationId={locationId} />
}
